export default __webpack_public_path__ + "static/media/app.dc268862.png";